import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {AppState} from '../../index';
import {NotificationService} from '../../../../services/notification.service';
import {actionLocation, deleteLocation, getAllLocations, loadLocations, upsertLocation} from './location.actions';
import {map, switchMap} from 'rxjs/operators';
import {GET_MEETING_LOCATION, SAVE_MEETING_LOCATION} from './location.graphql';
import {Apollo} from 'apollo-angular';
import {ActionTypeEnum} from '../../../../shared/enums/data.enums';
import {SettingsService} from '../../../../services/settings.service';

@Injectable()
export class LocationEffects {

  get = createEffect(() => this.actions$.pipe(
    ofType(getAllLocations),
    switchMap(() => {
      return this.apollo.query({
        query: GET_MEETING_LOCATION
      }).pipe(
        map(({ data }: any) => {
          const result: any = Object.values(data)[0];

          if (result !== null && result?.response?.code === 9000) {
            this.store.dispatch(loadLocations({locations: result?.data}));
          }
        })
      );
    })
  ), { dispatch: false });

  save = createEffect(() => this.actions$.pipe(
    ofType(actionLocation),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: SAVE_MEETING_LOCATION,
        variables: { inputDto: action.locationDto }
      }).pipe(
        map(({ data }: any) => {
          const result: any = Object.values(data)[0];

          if (result !== null && result?.response?.code === 9000){
            this.notificationService.successMessageAndCloseModals(result?.response?.message);
            if (action.locationDto.actionType === ActionTypeEnum.delete){
              this.store.dispatch(deleteLocation({id: action.id}));
              this.settingsService.reloadCurrentRoute(null);
            }
            this.store.dispatch(upsertLocation({location: result?.data}));

          }else {
            this.notificationService.errorMessage(result?.response?.message);
          }
        })
      );
    })
  ), { dispatch: false });

  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
    private settingsService: SettingsService,
    private notificationService: NotificationService,
    private apollo: Apollo
  ) {
  }
}
